import { Details } from '@/store/orders/order.types'

import {
  Ecommerce,
  EcommerceEventName,
  EcommerceProduct,
} from '@/services/metrics/types/ecommerce.types'
import { Item as OrderItem } from '@/types/api/api-v3/orders/order'
import type { CommonProductModification } from '@/types/products'

const BRAND_NAME = 'Farfor'

/**
 * Генерируем объект для отправки ecommerce событий просмотра и удаления добавления продукта
 * Сигнатура объекта: https://yandex.ru/support/metrica/ecommerce/data.html
 * @param currencyData - модификация продукта
 * @param eventName - событие ecommerce
 * @param currencyCode - тип валюты
 * @param quantity - количество продукта
 */
export const mapEcommerceData = (
  currencyData: CommonProductModification,
  eventName: EcommerceEventName,
  currencyCode: string,
  quantity?: number,
): Ecommerce => {
  const products: EcommerceProduct[] = []

  products.push({
    id: String(currencyData.id),
    name: currencyData.name || '',
    variant: currencyData.full_name,
    price: currencyData.price || 0,
    brand: BRAND_NAME,
    ...(currencyData.category_name && { category: currencyData.category_name }),
    ...(quantity && { quantity }),
  })

  return {
    ecommerce: {
      currencyCode,
      [eventName]: {
        products,
      },
    },
  }
}

/**
 * Генерируем объект для отправки ecommerce событий оформления заказа
 * Сигнатура объекта: https://yandex.ru/support/metrica/ecommerce/data.html
 * @param productsOfOrder - модель продукта заказа
 * @param orderId - номер заказа
 * @param details - детальная информация заказа
 */
export const mapOrderToEcommerce = (
  productsOfOrder: OrderItem[],
  orderId: number,
  details?: Partial<Details>,
): Ecommerce => {
  const eventName: EcommerceEventName = EcommerceEventName.PURCHASE

  const products: EcommerceProduct[] = productsOfOrder.map(
    (item: OrderItem) => ({
      id: String(item.product.id),
      name: item.product.name,
      price: item.price,
      quantity: item.quantity,
      category: item.product.category_name,
      brand: BRAND_NAME,
    }),
  )

  return {
    ecommerce: {
      currencyCode: details?.currency_symbol,
      [eventName]: {
        actionField: {
          id: orderId,
          ...(details?.promocode && { coupon: details?.promocode }),
          ...(details?.cash_price && { revenue: details?.cash_price }),
        },
        products,
      },
    },
  }
}
